// extracted by mini-css-extract-plugin
module.exports = {"status":"ReasonToUpload-module__status--1b3Xs","rejectionReason":"ReasonToUpload-module__rejectionReason--2yXUf"};